module.exports = __webpack_public_path__ + "static/back2-c4c586e6d53233d25e20d4b5e8e87cfb.png";